/**
 * 简化的持久化层
 * 
 * 注意：已移除 Tauri SQL 插件依赖
 * TanStack DB 使用内存存储 + Electric 同步
 * 数据持久化由 Electric 负责，通过 PostgreSQL 存储
 * 
 * Electric + TanStack DB 最佳实践：
 * - Electric 从 PostgreSQL 同步数据到客户端
 * - TanStack DB 在内存中管理状态
 * - 不需要本地 SQLite 持久化
 */

// 注意：此文件保留用于兼容性，但不再初始化 Tauri SQL 数据库
// 所有数据操作通过 TanStack DB Collection 直接进行

let isInitialized = false

/**
 * 初始化数据库（现在为空操作，保留用于兼容性）
 */
export async function initializeDatabase(): Promise<void> {
  if (isInitialized) {
    console.log('[TauriDatabase] 已初始化，跳过')
    return
  }

  console.log('[TauriDatabase] 初始化（简化模式，无本地 SQLite）')
  
  // 注意：已移除 Tauri SQL 插件调用
  // TanStack DB 使用内存存储 + Electric 同步
  // 数据持久化由 PostgreSQL 通过 Electric 处理
  
  isInitialized = true
  console.log('[TauriDatabase] 初始化完成（使用内存存储 + Electric 同步）')
}

/**
 * 获取数据库（已弃用，保留用于兼容性）
 */
export function getDatabase(): never {
  throw new Error('Tauri SQL 插件已移除。请使用 TanStack DB Collection 直接操作数据。')
}

/**
 * 获取持久化层（已弃用，保留用于兼容性）
 */
export function getPersistence(): never {
  throw new Error('Tauri SQLite 持久化已移除。请使用 TanStack DB Collection 直接操作数据。')
}

/**
 * 检查数据库是否已初始化
 */
export function isDatabaseInitialized(): boolean {
  return isInitialized
}

/**
 * 关闭数据库（现在为空操作）
 */
export async function closeDatabase(): Promise<void> {
  isInitialized = false
  console.log('[TauriDatabase] 已关闭')
}

// 注意：以下导出保留用于兼容性，但会抛出错误
// 签名保留 sql/params 形参以兼容旧调用点（运行时恒抛错，不执行任何 SQL）
export async function query<T = any>(_sql?: string, _params?: (string | number)[]): Promise<T[]> {
  throw new Error('Tauri SQL 插件已移除。请使用 TanStack DB Collection 直接操作数据。')
}

export async function execute(_sql?: string, _params?: (string | number)[]): Promise<void> {
  throw new Error('Tauri SQL 插件已移除。请使用 TanStack DB Collection 直接操作数据。')
}
